module.exports = __webpack_public_path__ + "static/img/jhg_detail4.487ca4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jhg_detail4.png
// module id = 0Vug
// module chunks = 0